var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_c('el-breadcrumb-item',[_vm._v("客户报表")]),_c('el-breadcrumb-item',[_vm._v("商品销售")])],1),_c('el-card',[_vm._v(" 正在建设中... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }